/*
 * @Author: your name
 * @Date: 2020-12-11 16:57:16
 * @LastEditTime: 2021-12-10 11:24:12
 * @LastEditors: Please set LastEditors
 * @Description: In User Settings Edit
 * @FilePath: \vue-gaokao-ebook\src\webconfig\webconfig.js
 */
//gk后端接口请求地址
let env = 'prod'

window.env = env

let backURL = '';
if (env == 'test') {
  backURL = "https://test.gk211985.com"
} else if(env == 'prod') {
  backURL = "https://www.gk211985.com"
} else if(env == 'dev') {
  // backURL = "http://192.168.1.34:8385"
  backURL = "https://test.gk211985.com"
}

window.backURL = backURL

//gk前端地址
let frontURL = ''
if (env == 'test') {
  frontURL = "https://test.gk211985.com"
} else if(env == 'prod') {
  frontURL = 'https://www.gk211985.com'
} else if(env == 'dev') {
  frontURL = "http://localhost:8389"
}

window.frontURL = frontURL

//知好乐手写笔连接地址
const penURL = "http://127.0.0.1:5101/newpen";

//微信相关
let wxInfo = {
  //appid  wxb9914d7bc72f2730
  appid : "wxd9aead31aa27d746",
  // appid : "wx25e5f6225f56fdaf",
  //扫码登录回调地址
  redirect_uri: '',
  bind_uri: '',
  client_redirect_uri: '',
  web_uri: ''
}

if (env == 'test') {
  wxInfo.redirect_uri = "https://test.gk211985.com:7443/#/tfedu_common/home"
  wxInfo.web_uri = 'https://test.gk211985.com:7443/#/shopping_mall'
  wxInfo.bind_uri = "https://test.gk211985.com:7443/#/client_setting?active_name=4"
  wxInfo.bind_web_uri = "https://test.gk211985.com:7443/#/web/setting?active_name=4"
  wxInfo.client_redirect_uri = "https://test.gk211985.com:7443/#/client_logining"
} else if(env == 'prod') {
  wxInfo.web_uri = 'https://www.gk211985.com/#/shopping_mall'
  wxInfo.redirect_uri = 'https://www.gk211985.com/#/tfedu_common/home'
  wxInfo.bind_uri = "https://www.gk211985.com/#/client_setting?active_name=4"
  wxInfo.bind_web_uri = "https://www.gk211985.com/#/web/setting?active_name=4"
  wxInfo.client_redirect_uri = "https://www.gk211985.com/#/client_logining"
} else if(env == 'dev') {
  wxInfo.web_uri = 'https://localhost:8389/#/shopping_mall'
  wxInfo.redirect_uri = "https://localhost:8389/#/tfedu_common/home"
  wxInfo.bind_uri = "https://localhost:8389/#/client_setting?active_name=4"
  wxInfo.bind_web_uri = "https://localhost:8389/#/web/setting?active_name=4"
  wxInfo.client_redirect_uri = "https://localhost:8389/#/client_logining"
}

export default{
  backURL,
  frontURL,
  penURL,
  wxInfo,
  env
}
